import React from 'react';

import {
  SearchResult,
} from '../../../components';

import GroupedContentFull from '../GroupedContent/Full';
import OpinionTeaser from './teaser';
import OpinionTeaserLarge from './teaser_large';

const Opinion = ({ entity, className, viewMode, ...props }) => {
  switch (viewMode) {
    case 'search_result':
      return (<SearchResult entity={entity} {...props} />);
    case 'teaser':
      return (<OpinionTeaser entity={entity} {...props} />);
    case 'teaser_large':
      return (<OpinionTeaserLarge entity={entity} {...props} />);
    case 'full':
    default:
      return (<GroupedContentFull entity={entity} {...props} />);
  }
};

export default Opinion;
